import { PureComponent } from 'react'
import { Box, Layout } from 'react-flex-lite'
import PropTypes from 'meta/PropTypes'
import { Paragraph } from 'components/display/Text'
import cn from 'classnames'
import { BaseLink } from 'components/interactive/LinkButton'
import cloudinary from 'connections/cloudinary'
import './index.scss'

const getImage = (place) =>
  cloudinary.url(place.theme.headerImage, {
    crop: 'fit',
    width: 570,
    height: 380
  })

const getSmallImage = (place) =>
  cloudinary.url(place.theme.headerImage, {
    crop: 'fit',
    height: 96
  })

@Layout
export default class PlaceCard extends PureComponent {
  static propTypes = {
    to: PropTypes.string,
    className: PropTypes.string,
    place: PropTypes.place.isRequired,
    full: PropTypes.bool
  }
  render = () => {
    const { className, place, full, to, ...rest } = this.props
    const ourClass = cn('place-card-component', className, { full })
    return <BaseLink column className={ourClass} to={to} {...rest}>
      {full
        ? <Box className="place-img" style={{ backgroundImage: `url(${getImage(place)})` }} />
        : <img alt={`${place.name} image`} className="place-img" src={getSmallImage(place)} />}
      <Box px={3} py={2} className="place-info">
        <Paragraph truncate weight="medium" className="place-name" title={place.name}>{place.displayName}</Paragraph>
        {/* disabled until we have an impressive number to show */}
        {/*<Small truncate className="place-data">{format(place.data)} rows</Small>*/}
      </Box>
    </BaseLink>
  }
}
